var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BA0229"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.005 21.8588L31.9747 13.3275C32.1169 12.7116 31.6413 12.125 30.9996 12.125H14.6337L14.2518 10.2871C14.1566 9.82899 13.7471 9.5 13.272 9.5H9C8.44771 9.5 8 9.94071 8 10.4844V11.1406C8 11.6843 8.44771 12.125 9 12.125H11.9118L14.8388 26.2112C14.1385 26.6076 13.6667 27.3509 13.6667 28.2031C13.6667 29.4717 14.7113 30.5 16 30.5C17.2887 30.5 18.3333 29.4717 18.3333 28.2031C18.3333 27.5602 18.0647 26.9794 17.6323 26.5625H26.3676C25.9353 26.9794 25.6667 27.5602 25.6667 28.2031C25.6667 29.4717 26.7113 30.5 28 30.5C29.2887 30.5 30.3333 29.4717 30.3333 28.2031C30.3333 27.2937 29.7963 26.5079 29.0175 26.1357L29.2474 25.14C29.3896 24.5241 28.914 23.9375 28.2723 23.9375H17.0882L16.8155 22.625H29.0299C29.4968 22.625 29.9015 22.307 30.005 21.8588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingMapIcon);
export default __webpack_public_path__ + "static/media/shopping-map-icon.7bcbd7c417f3af483d4a1253f0a80be6.svg";
export { ForwardRef as ReactComponent };